/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
function e(){return[1,0,0,1]}function r(e){return[e[0],e[1],e[2],e[3]]}function t(e,r,t,n){return[e,r,t,n]}function n(e,r){return new Float64Array(e,r,4)}const o=Object.freeze(Object.defineProperty({__proto__:null,create:e,clone:r,fromValues:t,createView:n},Symbol.toStringTag,{value:"Module"}));export{r as a,n as b,e as c,t as f,o as m};
